customElements.define(
  'sticky-product-form',
  class StickyProductForm extends HTMLElement {
    constructor() {
      super();

      this.onScrollHandler = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.productForm = document.querySelector('product-form');
      this.productStickyForm = document.querySelector('.product--sticky-form');
      this.atcButton = document.querySelector(
        '.product-form .product-form__submit'
      );

      // Stop if the required sticky-form elements are unavailable.
      if (!this.productStickyForm || !this.atcButton) return;

      window.addEventListener('scroll', this.onScrollHandler, {
        passive: true,
      });

      // Set the correct initial state.
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (!this.atcButton || !this.productStickyForm) return;

      const atcButtonBottom = this.atcButton.getBoundingClientRect().bottom;

      if (atcButtonBottom < 0) {
        requestAnimationFrame(() => this.reveal());
      } else {
        requestAnimationFrame(() => this.hide());
      }
    }

    hide() {
      if (
        !this.productStickyForm ||
        !this.productStickyForm.classList.contains(
          'product--sticky-form__active'
        )
      ) {
        return;
      }

      this.productStickyForm.classList.remove(
        'product--sticky-form__active'
      );
      this.productStickyForm.classList.add(
        'product--sticky-form__inactive'
      );

      const chatButton = document.getElementById('chat-button');
      const popupVideo = document.getElementById('ae-popup-video-pdp');

      if (chatButton) {
        chatButton.style.height = '66px';
      }

      if (popupVideo) {
        popupVideo.style.bottom = '20px';
      }
    }

    reveal() {
      if (
        !this.productStickyForm ||
        !this.productStickyForm.classList.contains(
          'product--sticky-form__inactive'
        )
      ) {
        return;
      }

      this.productStickyForm.classList.add(
        'product--sticky-form__active'
      );
      this.productStickyForm.classList.remove(
        'product--sticky-form__inactive'
      );

      const chatButton = document.getElementById('chat-button');
      const popupVideo = document.getElementById('ae-popup-video-pdp');

      if (chatButton) {
        chatButton.style.height = '170px';
      }

      if (popupVideo) {
        popupVideo.style.bottom = '120px';
      }
    }
  }
);